import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { Background } from '../../../types/background';
import { SanityResource, SanityResourcesTag } from '../../../types/common';
import List from '../../List';
import ResourceCard from '../../ResourceCard';

type ExternalContentProps = {
  data: {
    background: Background;
    title?: string | null;
    description?: string | null;
    filterTags?: SanityResourcesTag[] | null;
    resources: SanityResource[];
  }
}

const ExternalContent: FunctionComponent<ExternalContentProps> = ({ data }) => {
  const [resources, setResources] = useState(data.resources);
  const [filteredTags, setFilteredTags] = useState<string[]>([]);

  const handleChangeFilteredTags = useCallback((tagId: string) => {
    setFilteredTags((prevState) => {
      if (prevState.includes(tagId)) {
        return prevState.filter(item => item !== tagId);
      }
      return prevState.concat(tagId);
    });
  }, []);

  const handleClearFilters = () => {
    setFilteredTags([]);
  }

  useEffect(() => {
    if (filteredTags.length === 0) {
      setResources(data.resources);
      return;
    }
    const filteredNodes = data.resources.filter((item) => {
      return filteredTags.includes(item.tag._id);
    });
    setResources(filteredNodes);
  }, [filteredTags]);

  return (
    <List
      className={data.background}
      header={(data.title || data.description) && (
        <>
          {data.title && <h2>{data.title}</h2>}
          {data.description && <p>{data.description}</p>}
        </>
      )}
      singularLabel='resource'
      pluralLabel='resources'
      items={
        resources.map(resource => (
          <ResourceCard
            key={resource._id}
            resource={resource}
          />
        ))
      }
      filter={data.filterTags ? {
        categories: data.filterTags,
        filteredCategories: filteredTags,
        onFilter: handleChangeFilteredTags,
        onClearFilters: handleClearFilters,
      } : undefined}
    />
  );
}

export default ExternalContent;
